import React from 'react';
import { Sparkles } from 'lucide-react';

export default function PageHeading({ eyebrow = '大师兄 · AI 服务', title, description, Icon = Sparkles }) {
  return (
    <div className="page-heading">
      <span className="page-heading-icon"><Icon size={28} strokeWidth={1.5} aria-hidden="true" /></span>
      <div>
        <p className="page-eyebrow">{eyebrow}</p>
        <h1>{title}</h1>
        {description && <p className="page-description">{description}</p>}
      </div>
      <span className="page-heading-spark" aria-hidden="true">✳</span>
    </div>
  );
}
